import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import { Stack, useTheme } from '@mui/material';
import { VButton, VTypography } from '@venti-components';
import styles from './InfoCard.styles';
import VIcon from '../../../Venti-UI-Kit/VIcon/VIcon';

const InfoCard = ({ classes, cardInfo }) => {
  const { link, icon, title, newTab, text, button, buttonText } = cardInfo;
  const { palette } = useTheme();

  const target = newTab ? '_blank' : '_self';

  return (
    <Card elevation={0} className={classes.card}>
      <Stack className={classes.descriptionInfo}>
        <VIcon name={icon} />
        <VTypography align="left" variant="body1" fontWeight={600}>
          {title}
        </VTypography>
        <VTypography align="left" color={palette.text.secondary} variant="body2">
          {text}
        </VTypography>
      </Stack>
      {button || (
        <VButton
          variant="secondary"
          target={target}
          href={link}
          label={buttonText || 'Ir'}
          fullWidth="always"
        />
      )}
    </Card>
  );
};

export default withStyles(styles)(InfoCard);
